import { ACTION_TYPES } from "../../../Constants";

export const setNewtimezone = (timezone) => ({
  type: ACTION_TYPES.TIMEZONE,
  payload: timezone,
});

export const setSystemlatitude = (latitude) => ({
  type: ACTION_TYPES.LATITUDE,
  payload: latitude,
});

export const setSystemlongitude = (longitude) => ({
  type: ACTION_TYPES.LONGITUDE,
  payload: longitude,
});